module.exports = __webpack_public_path__ + "img/customer-a-011.66154d5c.png";